module.exports = __webpack_public_path__ + "static/media/1.14.54536a3d.png";